import React from "react";
import {
  AdditionalInformationIcon,
  PatientExcludedIcon,
  PatientIncludedIcon,
  PatientUndeterminedIcon,
  ProjectDetailsIcon,
  ProjectFiltersIcon,
  VisitRelationship,
  ProjectUnlockIcon,
  ProjectLockIcon,
  ProjectKeywordsIcon,
  CategorizationIcon,
  PatientDicomIcon,
  CohortUpdateIcon,
} from "../../customicons/CustomIcons";

const projectFiltersIcon = [
  "Demographic Filters",
  "Diagnosis Code Filters",
  "Procedure Code Filters",
];
export default function PatientsLogIcons({
  log,
}: {
  log: ActivityLogWithDate;
}) {
  if (!log.type) {
    return <DefaultComponent />;
  }
  if (log.type.category === "Patient Categorization") {
    if (!log.patientAttributeType) {
      return <DefaultComponent />;
    }

    const logSubType = log.patientAttributeType.name.toLowerCase();
    if (logSubType) {
      return (
        <CategorizationIcon
          type={log.type.action}
          attributeType={log.patientAttributeType}
        />
      );
    }
  }
  if (log.type.category === "Patient Include/Exclude") {
    if (log.value === "Included") {
      return <PatientIncludedIcon />;
    }
    if (log.value === "Excluded") {
      return <PatientExcludedIcon />;
    }
    if (log.value === "Undetermined") {
      return <PatientUndeterminedIcon />;
    }
  }
  if (log.type.category === "Additional Information") {
    return <AdditionalInformationIcon type={log.type.action} />;
  }
  if (log.type.category === "Visit Related/Not Related") {
    return <VisitRelationship type={log.type.action} />;
  }
  if (projectFiltersIcon.includes(log.type.category)) {
    return <ProjectFiltersIcon type={log.type.action} />;
  }
  if (log.type.category === "Project Details") {
    return <ProjectDetailsIcon type={log.type.action} />;
  }
  if (log.type.category === "Project Lock") {
    return log.value === "locked" ? (
      <ProjectLockIcon type={log.type.action} />
    ) : (
      <ProjectUnlockIcon type={log.type.action} />
    );
  }
  if (log.type.category === "Project Keywords") {
    return <ProjectKeywordsIcon type={log.type.action} />;
  }
  if (log.type.category === "Dicom Annotation") {
    return <PatientDicomIcon type={log.type.action} />;
  }
  if (log.type.category === "Patient Cohort") {
    return <CohortUpdateIcon type={log.type.action} />;
  }
  return <DefaultComponent />;
}

function DefaultComponent() {
  return <div></div>;
}
